import { render, staticRenderFns } from "./wine-lovers-registration.vue?vue&type=template&id=57ccf20b&scoped=true"
import script from "./wine-lovers-registration.vue?vue&type=script&lang=js"
export * from "./wine-lovers-registration.vue?vue&type=script&lang=js"
import style0 from "./wine-lovers-registration.vue?vue&type=style&index=0&id=57ccf20b&prod&scoped=true&lang=css"
import style1 from "./wine-lovers-registration.vue?vue&type=style&index=1&id=57ccf20b&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ccf20b",
  null
  
)

export default component.exports